import CategoryLinkComponent from "./category-link-component";

export default CategoryLinkComponent